import {digitsEnToFa, digitsFaToEn} from "persian-tools2";
import {patientDiabetType, patientInsulinType, patientPregnancyType} from 'helpers/Functions';

const userInfoObject = (patientInfo, serialNumber) => {
    const diabetYearToPersian = digitsEnToFa(patientInfo?.yearsWithDiabet);
    const diabetYearText =
        patientInfo?.yearsWithDiabet !== 0 && patientInfo?.yearsWithDiabet
            ? `${diabetYearToPersian} سال`
            : patientInfo?.yearsWithDiabet === 0
                ? 'زیر یک سال'
                : '';
    const userInfo = []
    userInfo.push(
        {title: 'تاریخ تولد', value: digitsEnToFa(patientInfo?.birthDate), id: 1},
        {
            title: 'جنسیت',
            value: patientInfo?.isMale
                ? 'مرد'
                : patientInfo?.isMale === false
                    ? 'زن'
                    : '',
            id: 2,
        },
        {
            title: 'نوع دیابت',
            value: patientDiabetType(patientInfo?.diabetType),
            id: 3,
        },
        {
            title: ' انسولین',
            value: digitsEnToFa(patientInsulinType(patientInfo?.insulinType)),
            id: 4,
        },
        {
            title: 'داروی خوراکی',
            value:
                (patientInfo?.isUsingOralMedications === true && 'بله') ||
                (patientInfo?.isUsingOralMedications === false && 'خیر') ||
                (patientInfo?.isUsingOralMedications === null && ''),
            id: 5,
        },
        {title: 'زمان شروع دیابت', value: digitsEnToFa(diabetYearText), id: 6}
    )
    if (patientInfo?.isMale === false)
        userInfo.push(
            {title: 'وضعیت بارداری', value: patientPregnancyType(patientInfo?.isPregnant), id: 7},
        )
    userInfo.push(
        {title: 'شماره تماس', value: digitsEnToFa(patientInfo?.phoneNumber), id: 8},
        {title: ' سریال دستگاه', value: digitsFaToEn(serialNumber), id: 9}
    )

    return userInfo;
};
export default userInfoObject; 